export enum FeatureProperty {
  TYPE = "type",
  COORDINATES = "coordinates",
  PROPERTIES = "properties",
  GEOMETRY = "geometry",
  ID = "id",
  NAME = "name",
  OUTLINE_COLOR = "outlineColor",
}


export enum FeatureType {
  STOP = 'fstop',
  SEGMENT = 'fsegment',
  OUTLINE = 'outline',
  TOWN_STOP = 'ftown_stop'
}

export enum GeometryType {
  POINT = 'Point',
  LINE_STRING = 'LineString',
  POLYGON = 'Polygon',
}